module.exports = __webpack_public_path__ + "5c8bed25a1a4d49e5815cc3718b61736.svg";